module.exports = __webpack_public_path__ + "static/media/auth-code-text.7b37516d.png";